export default {
  address: 'Адрес',
  firstName: 'Имя',
  lastName: 'Фамилия',
  middleName: 'Отчество',
  phone: 'Телефон',
  firstPhone: 'Телефон 1',
  secondPhone: 'Телефон 2',
  thirdPhone: 'Телефон 3',
  company: 'Компания',
  job: 'Должность',
  email: 'Email',
  newEmail: 'Новый почтовый ящик',
  region: 'Регион',
  city: 'Город',
  district: 'Район',
  street: 'Улица',
  house: 'Дом',
  building: 'Дом',
  office: 'Офис',
  seriesAndNumber: 'Серия и номер',
  dateOfIssue: 'Дата выдачи',
  issuer: 'Кем выдан',
  issuerCode: 'Код подразделения',
  passport: 'Паспорт',
  birthday: 'День рождения',
};
